<app-header extraClass="nav-down text-gray-innerMenu" displayNavigation="true"></app-header>
<section class="about-us-wrp mt-130">

  <div class="container">
    <div class="heading">
      <h4>About Things2do</h4>
      <p>We’re a passionate team of 100+ explorers who curate experiences that add luxury to life and excitement to your
        social calendar. From celebrating existing occasions to creating brand new milestones and memories, Things2do
        will always show you new ways to live your best life with pockets of adventure, elegance, style and exclusivity
        through experiences like you've never seen or even imagined before. </p>
    </div>
    <div class="about-big-img uk-flex uk-flex-between mt-5 mb-5">
      <div class="w-49">
        <img src="assets/images/img-8.jpg" alt="">
      </div>
      <div class="w-49">
        <img src="assets/images/img-7.jpg" alt="">
      </div>
    </div>
    <div class="info">
      <p>With a presence across 7 cities and a community of 10 million, in the past 4 years, we’ve been your best friend
        to scout and tell you about brilliant hyperlocal experiences across cities. We’re now using that expertise to
        give your weekend and social calendar the facelift it deserves. By picking the best and most exclusive
        experiences for you, in a way where with just a few clicks, you can open yourself to a world of super exciting
        Things 2do. Get on board and make a wish because we’ve taken our role as your experience genie to the next level
        so you can create lifelong memories with the people in your life that truly matter!</p>
    </div>

  </div>

  <div class="community-wrap mt-6">
    <div class="container">
      <div class="sub-heading">
        <h4>Our Communities</h4>
      </div>
      <div class="city-wrp mt-5">
        <ul class="uk-flex uk-flex-wrap">
          <li class="uk-transition-toggle">
            <a class="uk-transition-scale-up uk-transition-opaque">
              <img src="assets/images/city/mumbai.png" alt="">
              <span>Mumbai</span>
            </a>
          </li>
          <li class="uk-transition-toggle">
            <a class="uk-transition-scale-up uk-transition-opaque">
              <img src="assets/images/city/pune.png" alt="">
              <span>Pune</span>
            </a>
          </li>
          <li class="uk-transition-toggle">
            <a class="uk-transition-scale-up uk-transition-opaque">
              <img src="assets/images/city/delhi.png" alt="">
              <span>Delhi</span>
            </a>
          </li>
          <li class="uk-transition-toggle">
            <a class="uk-transition-scale-up uk-transition-opaque">
              <img src="assets/images/city/bengaluro.png" alt="">
              <span>Bengaluru</span>
            </a>
          </li>

          <li class="uk-transition-toggle">
            <a class="uk-transition-scale-up uk-transition-opaque">
              <img src="assets/images/city/kolkatta.png" alt="">
              <span>Kolkata</span>
            </a>
          </li>
          <li class="uk-transition-toggle">
            <a class="uk-transition-scale-up uk-transition-opaque">
              <img src="assets/images/city/ahmedbad.png" alt="">
              <span>Ahemdabad</span>
            </a>
          </li>
          <li class="uk-transition-toggle">
            <a class="uk-transition-scale-up<p>about works!</p>
 uk-transition-opaque">
              <img src="assets/images/city/singapur.png" alt="">
              <span>Singapore</span>
            </a>
          </li>
          <li class="uk-transition-toggle">
            <a class="uk-transition-scale-up uk-transition-opaque">
              <img src="assets/images/city/dubai.png" alt="">
              <span>Dubai</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>
